import { AspectRatio, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Technology = () => {
  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      py={{
        base: '40px',
        sm: '10px',
        md: '40px',
        lg: '60px',
        xl: '80px',
        '2xl': '100px'
      }}
      flexDir={{
        base: 'column',
        md: 'row'
      }}
      alignItems="center"
    >
      <VStack
        w={{
          base: '100%',
          sm: '80%',
          md: '100%'
        }}
        mt={{
          base: '0px',
          sm: '40px',
          md: '0px'
        }}
        alignItems="flex-start"
      >
        <AspectRatio
          w={{
            base: '40px',
            sm: '50px',
            md: '60px',
            lg: '70px',
            xl: '80px'
          }}
          ratio={1 / 1}
          position="relative"
          zIndex={10}
          mb={4}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-technology-1711633091559.png"
            alt="icon technology"
            fill
          />
        </AspectRatio>
        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w="100%"
        >
          SWEAT-FREE TECHNOLOGY
        </Text>
        <Text textStyle="gripContentSmall" textAlign="left" w="100%">
          Don't let condensation dampen your spirits. Our tumbler is equipped
          with advanced sweat-free technology, ensuring your hands stay dry and
          your grip firm.
        </Text>
        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w="100%"
          mt={5}
        >
          NO METALLIC TASTE
        </Text>
        <Text textStyle="gripContentSmall" textAlign="left" w="100%">
          Experience the true flavor of your beverages. The Arctic Grip Tumbler
          leaves no metallic aftertaste, ensuring each sip is as delightful as
          the first.
        </Text>
      </VStack>

      <VStack
        w={{
          base: '100%',
          sm: '80%',
          md: '30%'
        }}
        position="relative"
        mt="28px"
      >
        <AspectRatio
          w={{
            base: '180px',
            sm: '260px',
            md: '300px',
            lg: '500px'
          }}
          ratio={1 / 1}
          position="relative"
          zIndex={10}
          mb={4}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-x-1711633091559.png"
            alt="tumbler x"
            fill
          />
        </AspectRatio>
      </VStack>
    </Flex>
  )
}

export default Technology
